import { render } from "./AiGeneratedFlashQuestion.vue?vue&type=template&id=64209f8e&scoped=true"
import script from "./AiGeneratedFlashQuestion.vue?vue&type=script&lang=js"
export * from "./AiGeneratedFlashQuestion.vue?vue&type=script&lang=js"

import "./AiGeneratedFlashQuestion.vue?vue&type=style&index=0&id=64209f8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64209f8e"]])

export default __exports__